import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Person from '../Person';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';

export default class Unit extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            buildingId: this.isNull(props.BuildingId) ? this.defaultGuid() : props.BuildingId,
            caller: props.Caller,
            data: null,
            loading: true,
            ownerGridVersion: this.uuidv4(),
            tenantGridVersion: this.uuidv4()
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/building/unit/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.numberPeople)) this.state.data.record.numberPeople = "0";
        if (this.isBlank(this.state.data.record.metrag)) this.state.data.record.metrag = "0";
        if (this.isBlank(this.state.data.record.roomCount)) this.state.data.record.roomCount = "0";
        if (this.isBlank(this.state.data.record.shareOfTotal)) this.state.data.record.shareOfTotal = "0";
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

        var owners = [];
        this.state.data.record.owners.forEach(ow => {
            var clone = Object.assign({}, ow);
            clone.startDate = this.convertMomentToDb(clone.startDate);
            clone.finishDate = this.convertMomentToDb(clone.finishDate);
            owners.push(clone);
        });

        var tenants = [];
        this.state.data.record.tenants.forEach(ow => {
            var clone = Object.assign({}, ow);
            clone.startDate = this.convertMomentToDb(clone.startDate);
            clone.finishDate = this.convertMomentToDb(clone.finishDate);
            tenants.push(clone);
        });

        this.httpPost("api/v1/building/unit/save", {
            id: this.state.id,
            buildingId: this.state.buildingId,
            floor: this.state.data.record.floor,
            code: this.state.data.record.code,
            unitNumber: this.state.data.record.unitNumber,
            numberPeople: parseInt(this.state.data.record.numberPeople),
            metrag: parseFloat(this.state.data.record.metrag),
            phone: this.state.data.record.phone,
            roomCount: parseInt(this.state.data.record.roomCount),
            shareOfTotal: parseInt(this.state.data.record.shareOfTotal),
            contractId: this.state.data.record.contractId,
            buildingUnitCategoryId: this.state.data.record.buildingUnitCategoryId,
            description: this.state.data.record.description,
            location: this.state.data.record.location,
            zipcode: this.state.data.record.zipcode,
            ab: this.state.data.record.ab,
            barg: this.state.data.record.barg,
            gaz: this.state.data.record.gaz,
            parking: this.state.data.record.parking,
            parking2: this.state.data.record.parking2,
            anbar: this.state.data.record.anbar,
            empty: this.state.data.record.empty,
            abBillNumber: this.state.data.record.abBillNumber,
            bargBillNumber: this.state.data.record.bargBillNumber,
            gazBillNumber: this.state.data.record.gazBillNumber,
            tellBillNumber: this.state.data.record.tellBillNumber,
            owners,
            tenants
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    addNewOwner() {
        var owner = {
            id: this.uuidv4(),
            personId: this.getDefaultGuid(),
            personName: '',
            startDate: null,
            finishDate: null,
            share: 6
        }
        this.state.data.record.owners.push(owner);
        this.setState({ ownerGridVersion: this.uuidv4() });
    }
    removeOwner(id) {
        var temp = [];
        this.state.data.record.owners.forEach(ow => {
            if (ow.id !== id) temp.push(ow);
        });
        this.state.data.record.owners = temp;
        this.setState({ ownerGridVersion: this.uuidv4() });
    }
    setOwnerPersonId(id, e) {
        this.state.data.record.owners.forEach(ow => {
            if (ow.id === id) {
                ow.personId = e.value;
                ow.personName = e.label;
            }
        });
        this.setState({ ownerGridVersion: this.uuidv4() });
    }
    setOwnerShare(id, e) {
        this.state.data.record.owners.forEach(ow => {
            if (ow.id === id) {
                ow.share = parseInt(e.target.value);
            }
        });
        this.setState({ ownerGridVersion: this.uuidv4() });
    }
    setOwnerStartDate(id, e) {
        this.state.data.record.owners.forEach(ow => {
            if (ow.id === id) {
                ow.startDate = e;
            }
        });
        this.setState({ ownerGridVersion: this.uuidv4() });
    }
    setOwnerFinishDate(id, e) {
        this.state.data.record.owners.forEach(ow => {
            if (ow.id === id) {
                ow.finishDate = e;
            }
        });
        this.setState({ ownerGridVersion: this.uuidv4() });
    }
    addNewTenant() {
        var tenant = {
            id: this.uuidv4(),
            personId: this.getDefaultGuid(),
            personName: '',
            startDate: null,
            finishDate: null,
        }
        this.state.data.record.tenants.push(tenant);
        this.setState({ tenantGridVersion: this.uuidv4() });
    }
    removeTenant(id) {
        var temp = [];
        this.state.data.record.tenants.forEach(ow => {
            if (ow.id !== id) temp.push(ow);
        });
        this.state.data.record.tenants = temp;
        this.setState({ tenantGridVersion: this.uuidv4() });
    }
    setTenantPersonId(id, e) {
        this.state.data.record.tenants.forEach(ow => {
            if (ow.id === id) {
                ow.personId = e.value;
                ow.personName = e.label;
            }
        });
        this.setState({ tenantGridVersion: this.uuidv4() });
    }
    setTenantStartDate(id, e) {
        this.state.data.record.tenants.forEach(ow => {
            if (ow.id === id) {
                ow.startDate = e;
            }
        });
        this.setState({ tenantGridVersion: this.uuidv4() });
    }
    setTenantFinishDate(id, e) {
        this.state.data.record.tenants.forEach(ow => {
            if (ow.id === id) {
                ow.finishDate = e;
            }
        });
        this.setState({ tenantGridVersion: this.uuidv4() });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{"width": "96%"}}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات واحد" : "افزودن واحد جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <ul className="nav nav-tabs mt-n3" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link active" data-bs-toggle="tab" href="#tab1" aria-selected="false" role="tab" tabindex="-1"><span>اطلاعات واحد</span></a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link" data-bs-toggle="tab" href="#tab2" aria-selected="false" tabindex="-1" role="tab"><span>مالکین</span></a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link" data-bs-toggle="tab" href="#tab3" aria-selected="false" tabindex="-1" role="tab"><span>اطلاعات مستاجر</span></a>
                                    </li>
                                </ul>

                                <div className="tab-content">
                                    <div className="tab-pane active" id="tab1" role="tabpanel">
                                        <div className="row">
                                            <div className="col-sm-1">
                                                <div className="form-group">
                                                    <label for="name" className="title1">کد</label>
                                                    <input type="text" defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">گروه</label>
                                                    <SelectAsync
                                                        defaultValue={this.state.data.record.buildingUnitCategoryId != this.getDefaultGuid() ? [{ value: this.state.data.record.buildingUnitCategoryId, label: this.state.data.record.buildingUnitCategoryTitle }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب گروه بندی"
                                                        defaultOptions
                                                        loadOptions={this.loadBuildingUnitCategoriesOptions}
                                                        isClearable={true}
                                                        onChange={e => this.isNull(e) ? this.state.data.record.buildingUnitCategoryId = this.getDefaultGuid() : this.state.data.record.buildingUnitCategoryId = e.value}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-1">
                                                <div className="form-group">
                                                    <label for="name" className="title1">طبقه</label>
                                                    <input type="text" defaultValue={this.state.data.record.floor} onChange={e => this.state.data.record.floor = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-1">
                                                <div className="form-group">
                                                    <label for="name" className="title1">واحد</label>
                                                    <input defaultValue={this.state.data.record.unitNumber} onChange={e => this.state.data.record.unitNumber = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-1">
                                                <div className="form-group">
                                                    <label for="name" className="title1">تعداد ساکنین</label>
                                                    <input defaultValue={this.state.data.record.numberPeople} onChange={e => this.state.data.record.numberPeople = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-1">
                                                <div className="form-group">
                                                    <label for="name" className="title1">متراژ</label>
                                                    <input defaultValue={this.state.data.record.metrag} onChange={e => this.state.data.record.metrag = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-1">
                                                <div className="form-group">
                                                    <label for="name" className="title1">تعداد اتاق</label>
                                                    <input defaultValue={this.state.data.record.roomCount} onChange={e => this.state.data.record.roomCount = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-1">
                                                <div className="form-group">
                                                    <label for="name" className="title1">سهم از کل</label>
                                                    <input defaultValue={this.state.data.record.shareOfTotal} onChange={e => this.state.data.record.shareOfTotal = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">موقعیت</label>
                                                    <select defaultValue={this.state.data.record.location} onChange={e => this.state.data.record.location = parseInt(e.target.value)} className="form-control input-sm">
                                                        <option value="1">مسکونی</option>
                                                        <option value="2">تجاری</option>
                                                        <option value="3">اداری</option>
                                                        <option value="4">تجاری - اداری</option>
                                                        <option value="5">مسکونی-تجاری</option>
                                                        <option value="6">سایر</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">شماره تماس</label>
                                                    <input defaultValue={this.state.data.record.phone} onChange={e => this.state.data.record.phone = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">کدپستی</label>
                                                    <input defaultValue={this.state.data.record.zipcode} onChange={e => this.state.data.record.zipcode = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">کنتر آب</label>
                                                    <input defaultValue={this.state.data.record.ab} onChange={e => this.state.data.record.ab = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">کنتر برق</label>
                                                    <input defaultValue={this.state.data.record.barg} onChange={e => this.state.data.record.barg = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">کنتر گاز</label>
                                                    <input defaultValue={this.state.data.record.gaz} onChange={e => this.state.data.record.gaz = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">شماره پارکینگ</label>
                                                    <input defaultValue={this.state.data.record.parking} onChange={e => this.state.data.record.parking = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">شماره پارکینگ 2</label>
                                                    <input defaultValue={this.state.data.record.parking2} onChange={e => this.state.data.record.parking2 = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">انباری</label>
                                                    <input defaultValue={this.state.data.record.anbar} onChange={e => this.state.data.record.anbar = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label for="name" className="title1">توضیحات</label>
                                                    <input defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">شناسه قبض آب</label>
                                                    <input maxLength="50" defaultValue={this.state.data.record.abBillNumber} onChange={e => this.state.data.record.abBillNumber = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">شناسه قبض برق</label>
                                                    <input maxLength="50" defaultValue={this.state.data.record.bargBillNumber} onChange={e => this.state.data.record.bargBillNumber = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">شناسه قبض گاز</label>
                                                    <input maxLength="50" defaultValue={this.state.data.record.gazBillNumber} onChange={e => this.state.data.record.gazBillNumber = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">شناسه قبض تلفن</label>
                                                    <input maxLength="50" defaultValue={this.state.data.record.tellBillNumber} onChange={e => this.state.data.record.tellBillNumber = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">قرارداد اجاره واحد</label>
                                                    <SelectAsync
                                                        defaultValue={this.state.data.record.contractId != this.getDefaultGuid() ? [{ value: this.state.data.record.contractId, label: this.state.data.record.contractTitle }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب قرار داد"
                                                        defaultOptions
                                                        loadOptions={this.loadContractsOptions}
                                                        onChange={e => this.state.data.record.contractId = e.value}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-2">
                                                <div className="form-group">
                                                    <input defaultChecked={this.state.data.record.empty} onChange={e => this.state.data.record.empty = e.target.checked} type="checkbox" />
                                                    واحد خالی می باشد
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="tab2" role="tabpanel">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <p>توجه: مالکینی که تاریخ اتمام مالکیت برایشان مشخص نشده باشد، به عنوان مالکان فعلی شناخته خواهند شد</p>
                                                <table className="table table-bordered table-hover acc_grid_row">
                                                    <thead>
                                                        <tr className="active">
                                                            <td>مالک</td>
                                                            <td style={{ "width": "70px" }}>سهم</td>
                                                            <td style={{ "width": "150px" }}>تاریخ شروع مالکیت</td>
                                                            <td style={{ "width": "150px" }}>تاریخ اتمام مالکیت</td>
                                                            <td style={{ "width": "35px" }}></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.data.record.owners.map(owner =>
                                                            <tr>
                                                                <td>
                                                                    <SelectAsync
                                                                        style={{ "width": "100%" }}
                                                                        defaultValue={owner.personId != this.defaultGuid() ? [{ value: owner.personId, label: owner.personName }] : null}
                                                                        isMulti={false}
                                                                        placeholder="انتخاب مالک"
                                                                        noOptionsMessage={({ inputValue }) =>
                                                                            inputValue ? "نتیجه‌ای یافت نشد" : null
                                                                        }
                                                                        components={{
                                                                            DropdownIndicator: () => null,
                                                                            IndicatorSeparator: () => null,
                                                                        }}
                                                                        defaultOptions={[]}
                                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, 0)}
                                                                        onChange={e => this.setOwnerPersonId(owner.id, e)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <select defaultValue={owner.share} onChange={e => this.setOwnerShare(owner.id, e)} className="form-control">
                                                                        <option value="1">1 دانگ</option>
                                                                        <option value="2">2 دانگ</option>
                                                                        <option value="3">3 دانگ</option>
                                                                        <option value="4">4 دانگ</option>
                                                                        <option value="5">5 دانگ</option>
                                                                        <option value="6">6 دانگ</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <DatePicker
                                                                        inputReadOnly={false}
                                                                        className="form-control persian-date ltr"
                                                                        placeholder={"تاریخ شروع"}
                                                                        isGregorian={false}
                                                                        showTodayButton={true}
                                                                        timePicker={false}
                                                                        onChange={(e) => { this.setOwnerStartDate(owner.id,e) }}
                                                                        value={this.getFormatedDateForDatePicker(owner.startDate)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <DatePicker
                                                                        inputReadOnly={false}
                                                                        className="form-control persian-date ltr"
                                                                        placeholder={"تاریخ پایان"}
                                                                        isGregorian={false}
                                                                        showTodayButton={true}
                                                                        timePicker={false}
                                                                        onChange={(e) => { this.setOwnerFinishDate(owner.id, e) }}
                                                                        value={this.getFormatedDateForDatePicker(owner.finishDate)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <span title="حذف سطر" onClick={e => this.removeOwner(owner.id)} className="fa fa-trash fa-fw close-grid-row"></span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <a className="btn btn-primary" onClick={e => this.addNewOwner()}>افزودن مالک جدید</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="tab3" role="tabpanel">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <p>توجه: مستاجری که تاریخ اتمام مالکیت برایش مشخص نشده باشد، به عنوان مستاجر فعلی شناخته خواهند شد</p>
                                                <table className="table table-bordered table-hover acc_grid_row">
                                                    <thead>
                                                        <tr className="active">
                                                            <td>مستاجر</td>
                                                            <td style={{ "width": "150px" }}>تاریخ ورود</td>
                                                            <td style={{ "width": "150px" }}>تاریخ خروج</td>
                                                            <td style={{ "width": "35px" }}></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.data.record.tenants.map(tenant =>
                                                            <tr key={tenant.id}>
                                                                <td>
                                                                    <SelectAsync
                                                                        style={{ "width": "100%" }}
                                                                        defaultValue={tenant.personId != this.defaultGuid() ? [{ value: tenant.personId, label: tenant.personName }] : null}
                                                                        isMulti={false}
                                                                        placeholder="انتخاب مستاجر"
                                                                        noOptionsMessage={({ inputValue }) =>
                                                                            inputValue ? "نتیجه‌ای یافت نشد" : null
                                                                        }
                                                                        components={{
                                                                            DropdownIndicator: () => null,
                                                                            IndicatorSeparator: () => null,
                                                                        }}
                                                                        defaultOptions={[]}
                                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, 0)}
                                                                        onChange={e => this.setTenantPersonId(tenant.id, e)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <DatePicker
                                                                        inputReadOnly={false}
                                                                        className="form-control persian-date ltr"
                                                                        placeholder={"تاریخ شروع"}
                                                                        isGregorian={false}
                                                                        showTodayButton={true}
                                                                        timePicker={false}
                                                                        onChange={(e) => { this.setTenantStartDate(tenant.id, e) }}
                                                                        value={this.getFormatedDateForDatePicker(tenant.startDate)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <DatePicker
                                                                        inputReadOnly={false}
                                                                        className="form-control persian-date ltr"
                                                                        placeholder={"تاریخ پایان"}
                                                                        isGregorian={false}
                                                                        showTodayButton={true}
                                                                        timePicker={false}
                                                                        onChange={(e) => { this.setTenantFinishDate(tenant.id, e) }}
                                                                        value={this.getFormatedDateForDatePicker(tenant.finishDate)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <span title="حذف سطر" onClick={e => this.removeTenant(tenant.id)} className="fa fa-trash fa-fw close-grid-row"></span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <a className="btn btn-primary" onClick={e => this.addNewTenant()}>افزودن مستاجر جدید</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}